import { IonContent } from '@ionic/react';
import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI/components/Title';
import { HARDCODED_CATEGORIES } from '../../constants';

import { ScreenFindAiImageStyles, PageStyles } from './FindAi.styles';

export const ScreenFindAi: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FindAi',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent>
        <div className="images-container">
          <ScreenFindAiImageStyles>
            <img
              src={`${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-1.png`}
              alt="girl 1"
            />
          </ScreenFindAiImageStyles>
          <ScreenFindAiImageStyles>
            <img
              src={`${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-2.png`}
              alt="girl 2"
            />
          </ScreenFindAiImageStyles>
          <ScreenFindAiImageStyles>
            <img
              src={`${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-3.png`}
              alt="girl 3"
            />
          </ScreenFindAiImageStyles>
          <ScreenFindAiImageStyles>
            <img
              src={`${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-4.png`}
              alt="girl 4"
            />
          </ScreenFindAiImageStyles>
        </div>
        <OwnAiTitle className="local-title">
          Let's find somebody who is
          <br /> perfect for you!
        </OwnAiTitle>
        <OnboardingSubtitle>
          We have a lot of AI's that met many different preferences for each
          user
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </PageStyles>
  );
};
